<div #screen>
    <lib-loading-spinner type="ball-atom"></lib-loading-spinner>
    <lib-toastr-notifications></lib-toastr-notifications>
    <router-outlet></router-outlet>
</div>
